<template>
    <div class="banner-content">
        <h2 class="banner-title">Taklaa raportointivaatimukset veloituksetta</h2>
        <p class="banner-desc">Vastuullisuusraportointi ei tarvitse olla raskas byrokratiahanke - me teemme siitä nopean ja vaikuttavan. Kun olet valmis syventämään vastuullisuustyötäsi, Suha kasvaa tarpeidesi mukana.</p>
        <li class="d-none d-md-block">
            <a class="btn btn-custom-size btn-md blackcurrant-color extbot-primary-hover" style="width: 12vw;" @click="scrollBelow">Luo raportti</a>
        </li>
    </div>
</template>

<script>
    export default {
        methods: {
            scrollBelow() {
                document.getElementById("pricing-container").scrollIntoView({behavior: 'smooth', block: 'center'})
            },
        },
    }
</script>
